"use client";

import {
  WayakFooter,
  WayakHeader,
  WayakMarketingStyles,
} from "./LandingExperience";

export default function LegalPage({
  title,
  description,
  src,
}: {
  title: string;
  description: string;
  src: string;
}) {
  return (
    <div className="v4-landing legal-page">
      <WayakMarketingStyles />
      <style>{`
        .legal-main { padding: 12px; background: var(--paper); }
        .legal-panel { overflow: hidden; border: 1px solid var(--line); border-radius: var(--radius-panel); background: var(--soft); }
        .legal-head { width: min(100% - 80px,1360px); margin: 0 auto; padding: 82px 0 48px; }
        .legal-head span { display: flex; align-items: center; gap: 11px; font-size: 10px; font-weight: 700; letter-spacing: .18em; text-transform: uppercase; }
        .legal-head span::before { content: ""; width: 26px; height: 1px; background: currentColor; opacity: .5; }
        .legal-head h1 { margin: 18px 0 0; font-size: clamp(48px,6vw,82px); line-height: .95; letter-spacing: -.05em; }
        .legal-head p { max-width: 620px; margin: 22px 0 0; color: var(--muted); font-size: 16px; line-height: 1.6; }
        .legal-frame-wrap { padding: 0 16px 16px; }
        .legal-frame { width: 100%; min-height: 760px; height: calc(100vh - 180px); display: block; border: 1px solid var(--line); border-radius: 18px; background: #fff; }
        .legal-page .v4-footer { margin-top: 16px; border-radius: var(--radius-panel); }
        @media (max-width: 820px) {
          .legal-main { padding: 8px; }
          .legal-panel { border-radius: 18px; }
          .legal-head { width: min(100% - 40px,1360px); padding: 64px 0 38px; }
          .legal-frame-wrap { padding: 0 8px 8px; }
          .legal-frame { min-height: 680px; border-radius: 13px; }
          .legal-page .v4-footer { margin: 8px; border-radius: 18px; }
        }
      `}</style>
      <WayakHeader />
      <main className="legal-main">
        <section className="legal-panel">
          <header className="legal-head">
            <span>Wayak legal</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </header>
          <div className="legal-frame-wrap">
            <iframe className="legal-frame" src={src} title={title} />
          </div>
        </section>
      </main>
      <WayakFooter />
    </div>
  );
}
